import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';

import {DateToDatePipe} from './pipe-date-to-date';
import {DateToDateTimePipe} from './pipe-date-to-datetime';
import {DateToTimePipe} from './pipe-date-to-time';
import {KeyValuePipe} from './pipe-key-value';

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    DateToDatePipe,
    DateToDateTimePipe,
    DateToTimePipe,
    KeyValuePipe,
  ],
  exports: [
    DateToDatePipe,
    DateToDateTimePipe,
    DateToTimePipe,
    KeyValuePipe,
  ],
})

export class PipesModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/shared/pipes/pipes.module.ts